/**
 * Модуль конфигов для слайдеров. Получаем объект, у которого ключ должен быть равен ключу
 * переданному в дата-атрибут data-slider-settings="mainPageSlider" обертки с классом js-slider
 * Таким образом можно управлять всеми конфигами в этом файле
 */
itsoftApp.createModule("slidersSettings", function () {
    // Локальные переменные
    const module = this;

    const Settings = {
        global: {
            slidesPerView: "auto",
            simulateTouch: false,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            followFinger: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            freeModeMomentum: false,
            speed: 500,
            on: {
                init: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const slider = swiperContainer.closest('.js-slider');
                    const sliderName = swiperContainer.getAttribute("data-slider-name");
                    
                    swiper.params.custom = {
                        swiperContainer: swiperContainer,
                        slider: slider,
                        sliderName: sliderName,
                    }

                    const customParams = swiper.params.custom;

                    if (sliderName) {
                        Swiper.initedSliders[sliderName] = this;
                    }
                }
            },

            breakpoints: {
                1024: {
                    slidesPerView: 3,
                }
            }
        },
        problems: {
            slidesPerView: "auto",
            freeModeMomentum: false,
            speed: 500,
            simulateTouch: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            on: {
                init: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const slider = swiperContainer.closest('.js-slider');
                    const sliderName = swiperContainer.getAttribute("data-slider-name");
                    
                    swiper.params.custom = {
                        swiperContainer: swiperContainer,
                        slider: slider,
                        sliderName: sliderName,
                    }

                    const customParams = swiper.params.custom;

                    if (sliderName) {
                        Swiper.initedSliders[sliderName] = this;
                    }
                },
            },
        },
        banner: {
            slidesPerView: "auto",
            freeModeMomentum: false,
            speed: 500,
            simulateTouch: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            on: {
                init: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const slider = swiperContainer.closest('.js-slider');
                    const sliderName = swiperContainer.getAttribute("data-slider-name");
                    
                    swiper.params.custom = {
                        swiperContainer: swiperContainer,
                        slider: slider,
                        sliderName: sliderName,
                    }

                    const customParams = swiper.params.custom;

                    if (sliderName) {
                        Swiper.initedSliders[sliderName] = this;
                    }
                },
            },
        },
        // Баннеры мобильного меню (header-main.php): по одному на экран, точки —
        // js-pagination-dots; создаётся из mobMenu.js при первом открытии меню
        menuBanner: {
            slidesPerView: 1,
            spaceBetween: 16,
            speed: 500,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
        },
        articles: {
            slidesPerView: "auto",
            freeModeMomentum: false,
            speed: 500,
            // simulateTouch: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            on: {
                init: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const slider = swiperContainer.closest('.js-slider');
                    const sliderName = swiperContainer.getAttribute("data-slider-name");
                    
                    swiper.params.custom = {
                        swiperContainer: swiperContainer,
                        slider: slider,
                        sliderName: sliderName,
                    }

                    const customParams = swiper.params.custom;

                    if (sliderName) {
                        Swiper.initedSliders[sliderName] = this;
                    }
                },
            },
        },
        brands: {
            slidesPerView: "auto",
            freeModeMomentum: false,
            speed: 500,
            simulateTouch: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            on: {
                init: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const slider = swiperContainer.closest('.js-slider');
                    const sliderName = swiperContainer.getAttribute("data-slider-name");
                    
                    swiper.params.custom = {
                        swiperContainer: swiperContainer,
                        slider: slider,
                        sliderName: sliderName,
                    }

                    const customParams = swiper.params.custom;

                    if (sliderName) {
                        Swiper.initedSliders[sliderName] = this;
                    }
                },
            },
        },
    };

    const getSettings = function (slidersSettingsKey) {
        return Settings[slidersSettingsKey];
    };

    module.getSettings = getSettings;
});